export const CVI_TYPES = [
  'leadECG',
  'documentationVT',
  'chestXRay',
  'echocardiogram',
  'cardiacCatheterization',
  'cmri',
  'wallMotionStudy',
  'stressTest',
];
